import { CreateRegistrationProps } from '@commenda/types/src/registration/types';
import { fetcher } from '@commenda/utils';

export async function createRegistration(
  businessEntityId: number,
  body: CreateRegistrationProps
) {
  const response = await fetcher(
    `business-entities/${businessEntityId}/registrations`,
    {
      method: 'POST',
      body,
    }
  );

  return response;
}
